import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import qs from 'qs';
import { 
  Search, 
  Edit2, 
  Filter, 
  DollarSign,
  Battery,
  User,
  Package,
  CheckCircle,
  XCircle,
  AlertCircle,
  ChevronRight,
  ChevronLeft,
  X,
  Save,
  Smartphone,
  Wrench,
  Hash,
  Calendar,
  Loader2,
  Plus
} from 'lucide-react';
import host from '../../assets/js/Host';

// Import Tailwind CSS and custom animations
const styles = `
@import url('https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css');

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideInUp {
  from { 
    opacity: 0;
    transform: translateY(20px);
  }
  to { 
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-fadeIn {
  animation: fadeIn 0.3s ease-out;
}

.animate-slideInUp {
  animation: slideInUp 0.3s ease-out;
}

/* Custom scrollbar styles */
.scrollbar-thin {
  scrollbar-width: thin;
}

.scrollbar-thin::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.scrollbar-thin::-webkit-scrollbar-track {
  background: #f3f4f6;
  border-radius: 3px;
}

.scrollbar-thin::-webkit-scrollbar-thumb {
  background: #d1d5db;
  border-radius: 3px;
}

.scrollbar-thin::-webkit-scrollbar-thumb:hover {
  background: #9ca3af;
}

/* Gradient text animation */
@keyframes gradientMove {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

.gradient-text {
  background: linear-gradient(45deg, #667eea, #764ba2, #f093fb, #667eea);
  background-size: 300% 300%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: gradientMove 4s ease infinite;
}

/* Modal styles with high specificity */
.modal-backdrop {
  position: fixed !important;
  inset: 0 !important;
  background-color: rgba(0, 0, 0, 0.6) !important;
  z-index: 99998 !important;
}

.modal-container {
  position: fixed !important;
  inset: 0 !important;
  z-index: 99999 !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
}

.modal-content {
  position: relative !important;
  z-index: 100000 !important;
  pointer-events: all !important;
}

/* Ensure all form elements are interactive */
.modal-content input,
.modal-content select,
.modal-content button,
.modal-content label {
  pointer-events: all !important;
  cursor: pointer !important;
}

/* Fix for radio buttons */
input[type="radio"] + label > div {
  cursor: pointer !important;
}

input[type="radio"]:checked + label > div {
  border-color: #4f46e5 !important;
  background-color: #eef2ff !important;
}

/* Smooth transition for table */
.table-transition {
  transition: opacity 0.3s ease;
}

.table-loading {
  opacity: 0.3;
  pointer-events: none;
}
`;


class ModernDeviceManagement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items_sana: [],
      filteredDevices: [],
      searchTerm: '',
      statusFilter: 'all',
      isEditModalOpen: false,
      selectedDevice: null,
      selectedStatus: '', // إضافة حالة للتحكم في الحالة المختارة
      admins: [],
      items: [],
      outItems: [],
      options: [],
      itemIn: {},
      itemOut: {},
      spin: false,
      isConfirmLoading: false,
      isTableLoading: false, // إضافة حالة تحميل الجدول
      parts_cost: 0,
      softCost: 0,
      battery_avg: 0,
      paybass: 0,
      inItems: 0,
      // Pagination states
      currentPage: 1,
      itemsPerPage: 50,
      totalPages: 1,
      totalItems: 0,
      // Stats by status
      statusStats: {}
    };
  }

  componentDidMount() {
    this.loadData(1, true);
    this.loadStatusStats();
    this.modalRoot = document.createElement('div');
    this.modalRoot.id = 'modal-root';
    document.body.appendChild(this.modalRoot);
  }

  componentDidUpdate(prevProps, prevState) {
    // إضافة/إزالة overflow hidden من body عند فتح/إغلاق Modal
    if (this.state.isEditModalOpen !== prevState.isEditModalOpen) {
      if (this.state.isEditModalOpen) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'unset';
      }
    }
  }

  componentWillUnmount() {
    // التأكد من إزالة overflow hidden عند إلغاء تحميل المكون
    document.body.style.overflow = 'unset';
    if (this.modalRoot && document.body.contains(this.modalRoot)) {
      document.body.removeChild(this.modalRoot);
    }
  }

  // تحميل إحصائيات الحالات
  loadStatusStats = async () => {
    try {
      const cookies = document.cookie.split(';').reduce((acc, cookie) => {
        const [key, value] = cookie.trim().split('=');
        acc[key] = value;
        return acc;
      }, {});

      const header = { 
        "Content-Type": "application/x-www-form-urlencoded", 
        token: cookies.token 
      };

      // محاولة تحميل الإحصائيات من API إذا كان متاحاً
      try {
        const statsResponse = await axios.get(host + `dashbord/sana/devs/stats/by-status`, { headers: header });
        if (statsResponse.data && statsResponse.data.statusCounts) {
          this.setState({ statusStats: statsResponse.data.statusCounts });
        }
      } catch (error) {
        console.log('Stats API not available, will calculate from data');
      }
    } catch (error) {
      console.error('Error loading status stats:', error);
    }
  }

  formatDate = (dateString) => {
    if (!dateString) return '-';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('EN-IQ', { 
        year: 'numeric', 
        month: '2-digit', 
        day: '2-digit' 
      });
    } catch {
      return dateString;
    }
  }

  loadData = async (page = 1, shouldLoadDropdowns = true) => {
    try {
      // إظهار spinner أثناء التحميل
      if (!shouldLoadDropdowns) {
        this.setState({ isTableLoading: true });
      }

      // تحميل القوائم المنسدلة مرة واحدة فقط
      if (shouldLoadDropdowns) {
        // تحميل الأجهزة للإدخال
        const itemsResponse = await axios.get(host + `users/get/items/sana/all?cat_id=2`);
        this.setState({ items: itemsResponse.data.items || [] });

        // تحميل الأجهزة للإخراج
        const outItemsResponse = await axios.get(host + `users/get/items/sana/all`);
        this.setState({ outItems: outItemsResponse.data.items || [] });

        // تحميل الموظفين
        const adminsResponse = await axios.get(host + `dashbord/admins/all`);
        const allAdmins = adminsResponse.data.admins || [];
        const maintenanceAdmins = allAdmins.filter(admin => admin.role === "صيانة");
        this.setState({ admins: maintenanceAdmins });
      }

      // تحميل بيانات الأجهزة الرئيسية مع pagination
      const cookies = document.cookie.split(';').reduce((acc, cookie) => {
        const [key, value] = cookie.trim().split('=');
        if (key && value) {
          acc[key] = value;
        }
        return acc;
      }, {});

      const header = { 
        "Content-Type": "application/x-www-form-urlencoded", 
        token: cookies.token || ''
      };

      // استخدام server-side pagination
      const params = {
        page: page,
        limit: this.state.itemsPerPage,
        search: this.state.searchTerm || '',
        status: this.state.statusFilter === 'all' ? '' : this.state.statusFilter,
        sortBy: 'id',
        sortOrder: 'DESC'
      };
      
      const devicesResponse = await axios.get(host + `dashbord/sana/devs/all/`, { 
        headers: header, 
        params 
      });
      
      const statusMap = {
        "-1": "معلق في الصيانة",
        "0": "سوفت",
        "1": "فحص",
        "2": "جاهز للمخزن",
        "3": "في المخزن",
        "4": "ملغي",
        "5": "معلق في السوفت",
        "6": "تم بيع الجهاز"
      };

      // معالجة البيانات من API
      const responseData = devicesResponse.data;
      const rawDevices = responseData.items || [];
      const processedDevices = rawDevices.map(item => ({
        ...item,
        status: String(item.status),
        statusLabel: statusMap[String(item.status)] || "غير محدد",
        paybassLabel: item.paybass ? "نعم" : "كلا",
        canEdit: String(item.status) !== "3",
        createdAtFormatted: this.formatDate(item.createdAt),
        updatedAtFormatted: this.formatDate(item.updatedAt)
      }));

      console.log('Loaded devices:', processedDevices.length);

      // استخدام البيانات من السيرفر
      this.setState({
        items_sana: processedDevices,
        filteredDevices: processedDevices,
        parts_cost: responseData.parts_cost || 0,
        softCost: responseData.softCost || 0,
        battery_avg: responseData.battery_avg || 0,
        totalPages: responseData.totalPages || 1,
        currentPage: responseData.currentPage || 1,
        totalItems: responseData.totalItems || 0,
        spin: true,
        isTableLoading: false // إخفاء السبنر
      });

      // تحميل إحصائيات الحالات بشكل منفصل
      this.loadStatusStats();

    } catch (error) {
      console.error('Error loading data:', error);
      this.setState({ 
        spin: true,
        filteredDevices: [],
        items_sana: [],
        isTableLoading: false // إخفاء السبنر حتى في حالة الخطأ
      });
    }
  }

  // دالة واحدة فقط لمعالجة التعديل
  handleEdit = async () => {
    // التحقق من وجوب تحديد حالة
    if (!this.state.selectedStatus) {
      alert('الرجاء تحديد حالة الجهاز');
      return;
    }

    try {
      this.setState({ isConfirmLoading: true });

      // جمع البيانات من الحقول
      const empSelect = document.getElementById('emp-select');
      const softPriceInput = document.getElementById('softPrice');
      
      const cookies = document.cookie.split(';').reduce((acc, cookie) => {
        const [key, value] = cookie.trim().split('=');
        if (key && value) {
          acc[key] = value;
        }
        return acc;
      }, {});

      const header = { 
        "Content-Type": "application/x-www-form-urlencoded", 
        token: cookies.token || ''
      };

      // بناء البيانات للإرسال - استخدم أسماء المعاملات الصحيحة للـ API القديم
      const updateData = {
        check: this.state.selectedStatus, // استخدام check بدلاً من status
        adminId: empSelect?.value !== 'none' ? empSelect.value : undefined,
        inItem: this.state.itemIn?.id || undefined,
        ouItem: this.state.itemOut?.id || undefined,
        softPrice: softPriceInput?.value || undefined
      };

      // إزالة القيم غير المعرفة
      Object.keys(updateData).forEach(key => {
        if (updateData[key] === undefined) {
          delete updateData[key];
        }
      });

      console.log('Sending update data:', updateData);

      // استدعاء API للتحديث باستخدام المسار الصحيح
      const response = await axios({
        method: 'POST',
        url: host + `users/sana/orders/edit/${this.state.selectedDevice.id}`,
        data: qs.stringify(updateData),
        headers: header
      });

      if (response.data.success !== false) {
        // إغلاق Modal
        this.setState({ 
          isEditModalOpen: false, 
          selectedDevice: null,
          selectedStatus: '',
          itemIn: {},
          itemOut: {},
          options: [],
          isConfirmLoading: false
        });

        // إعادة تحميل البيانات
        await this.loadData(this.state.currentPage, false);
        
        // إظهار رسالة نجاح
        alert('تم تحديث الجهاز بنجاح!');
      } else {
        throw new Error(response.data?.message || 'فشل التحديث');
      }

    } catch (error) {
      console.error('Error updating device:', error);
      alert('حدث خطأ أثناء تحديث الجهاز: ' + (error.response?.data?.message || error.message));
      this.setState({ isConfirmLoading: false });
    }
  }

  handleSearch = (value) => {
    console.log('Search value:', value);
    this.setState({ searchTerm: value, currentPage: 1 }, () => {
      this.loadData(1, false); // إعادة تحميل من السيرفر مع البحث الجديد
    });
  }

  handleStatusFilter = (value) => {
    console.log('Filter status:', value);
    this.setState({ statusFilter: value, currentPage: 1 }, () => {
      this.loadData(1, false); // إعادة تحميل من السيرفر مع الفلتر الجديد
    });
  }

  handlePageChange = (page) => {
    this.setState({ currentPage: page }, () => {
      this.loadData(page, false); // تحميل الصفحة الجديدة من السيرفر
    });
  }

  handleItemsPerPageChange = (value) => {
    const newItemsPerPage = parseInt(value);
    this.setState({ 
      itemsPerPage: newItemsPerPage,
      currentPage: 1 // Reset to first page
    }, () => {
      this.loadData(1, false); // إعادة تحميل مع عدد العناصر الجديد
    });
  }

  renderModal = () => {
    if (!this.state.isEditModalOpen || !this.modalRoot) return null;

    const modalContent = (
      <div 
        style={{
          position: 'fixed',
          top: '0',
          left: '0',
          width: '100vw',
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 2147483647 // أعلى قيمة z-index ممكنة
        }}
      >
        {/* Backdrop */}
        <div 
          style={{
            position: 'absolute',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            cursor: 'pointer'
          }}
          onClick={() => this.setState({ isEditModalOpen: false, selectedStatus: '' })}
        />
        
        {/* Modal Content */}
        <div 
          style={{
            position: 'relative',
            backgroundColor: 'white',
            borderRadius: '12px',
            width: '90%',
            maxWidth: '600px',
            maxHeight: '90vh',
            display: 'flex',
            flexDirection: 'column',
            boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
            margin: '20px'
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Header */}
          <div style={{
            padding: '20px',
            background: 'linear-gradient(to right, #4f46e5, #9333ea)',
            color: 'white',
            borderTopLeftRadius: '12px',
            borderTopRightRadius: '12px'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h2 style={{ fontSize: '20px', fontWeight: 'bold', margin: 0 }}>تعديل الجهاز</h2>
              <button
                onClick={() => this.setState({ isEditModalOpen: false, selectedStatus: '' })}
                style={{
                  background: 'transparent',
                  border: 'none',
                  color: 'white',
                  fontSize: '28px',
                  cursor: 'pointer',
                  padding: '0',
                  width: '32px',
                  height: '32px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  lineHeight: '1'
                }}
              >
                ×
              </button>
            </div>
            <p style={{ marginTop: '8px', opacity: 0.9, fontSize: '14px' }}>
              جهاز رقم {this.state.selectedDevice?.id} - {this.state.selectedDevice?.uudi}
            </p>
          </div>

          {/* Body */}
          <div style={{ 
            padding: '20px', 
            overflowY: 'auto',
            flex: 1
          }}>
            {/* Employee Select */}
            <div style={{ marginBottom: '16px' }}>
              <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500' }}>
                اسم الموظف
              </label>
              <select 
                id="emp-select"
                style={{
                  width: '100%',
                  padding: '8px 12px',
                  border: '1px solid #d1d5db',
                  borderRadius: '6px',
                  fontSize: '14px',
                  backgroundColor: 'white',
                  cursor: 'pointer'
                }}
                defaultValue={this.state.selectedDevice?.admin_id || "none"}
              >
                <option value="none">اختر الموظف</option>
                {this.state.admins.map(emp => (
                  <option key={emp.id} value={emp.id}>{emp.name}</option>
                ))}
              </select>
            </div>

            {/* Devices */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
              <div>
                <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500' }}>
                  الجهاز الأولي
                </label>
                <select 
                  style={{
                    width: '100%',
                    padding: '8px 12px',
                    border: '1px solid #d1d5db',
                    borderRadius: '6px',
                    fontSize: '14px',
                    backgroundColor: 'white',
                    cursor: 'pointer'
                  }}
                  onChange={(e) => {
                    const selected = this.state.items.find(item => item.id == e.target.value);
                    if (selected) this.onSelectIn(selected);
                  }}
                  defaultValue={this.state.selectedDevice?.item_in_id || ""}
                >
                  <option value="">اختر الجهاز</option>
                  {this.state.items.map(device => (
                    <option key={device.id} value={device.id}>{device.name}</option>
                  ))}
                </select>
              </div>
              
              <div>
                <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500' }}>
                  الجهاز النهائي
                </label>
                <select 
                  style={{
                    width: '100%',
                    padding: '8px 12px',
                    border: '1px solid #d1d5db',
                    borderRadius: '6px',
                    fontSize: '14px',
                    backgroundColor: 'white',
                    cursor: 'pointer'
                  }}
                  onChange={(e) => {
                    const selected = this.state.outItems.find(item => item.id == e.target.value);
                    if (selected) this.setState({ itemOut: selected });
                  }}
                  defaultValue={this.state.selectedDevice?.item_out_id || ""}
                >
                  <option value="">اختر الجهاز</option>
                  {this.state.outItems.map(device => (
                    <option key={device.id} value={device.id}>{device.name}</option>
                  ))}
                </select>
              </div>
            </div>

            {/* Software Cost */}
            <div style={{ marginBottom: '16px' }}>
              <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500' }}>
                تكلفة السوفت
              </label>
              <input
                id="softPrice"
                type="number"
                placeholder="0"
                defaultValue={this.state.selectedDevice?.softCost || ""}
                style={{
                  width: '100%',
                  padding: '8px 12px',
                  border: '1px solid #d1d5db',
                  borderRadius: '6px',
                  fontSize: '14px'
                }}
              />
            </div>

            {/* Status Selection */}
            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: '500' }}>
                حالة الجهاز
              </label>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '8px' }}>
                {[
                  { value: "1", label: "فحص" },
                  { value: "0", label: "سوفت" },
                  { value: "2", label: "جاهز للمخزن" },
                  { value: "5", label: "معلق في السوفت" },
                  { value: "-1", label: "معلق في الصيانة" }
                ].map(status => {
                  const isSelected = this.state.selectedStatus === status.value;
                  return (
                    <div 
                      key={status.value}
                      onClick={() => {
                        console.log('تم اختيار الحالة:', status.value);
                        this.setState({ selectedStatus: status.value });
                      }}
                      style={{
                        padding: '12px',
                        border: isSelected ? '2px solid #4f46e5' : '2px solid #e5e7eb',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        backgroundColor: isSelected ? '#eef2ff' : 'white',
                        textAlign: 'center',
                        fontWeight: '500',
                        fontSize: '14px',
                        color: isSelected ? '#4f46e5' : '#374151',
                        transition: 'all 0.2s',
                        userSelect: 'none'
                      }}
                      onMouseEnter={(e) => {
                        if (!isSelected) {
                          e.currentTarget.style.borderColor = '#9ca3af';
                          e.currentTarget.style.backgroundColor = '#f9fafb';
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (!isSelected) {
                          e.currentTarget.style.borderColor = '#e5e7eb';
                          e.currentTarget.style.backgroundColor = 'white';
                        }
                      }}
                    >
                      {status.label}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          {/* Footer */}
          <div style={{
            padding: '20px',
            borderTop: '1px solid #e5e7eb',
            display: 'flex',
            gap: '12px'
          }}>
            <button 
              onClick={this.handleEdit}
              disabled={this.state.isConfirmLoading}
              style={{
                flex: 1,
                padding: '10px',
                backgroundColor: this.state.isConfirmLoading ? '#9ca3af' : '#4f46e5',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                fontSize: '14px',
                fontWeight: '500',
                cursor: this.state.isConfirmLoading ? 'not-allowed' : 'pointer',
                opacity: this.state.isConfirmLoading ? 0.5 : 1
              }}
            >
              {this.state.isConfirmLoading ? 'جاري الحفظ...' : 'حفظ التعديلات'}
            </button>
            
            <button
              onClick={() => this.setState({ isEditModalOpen: false, selectedStatus: '' })}
              style={{
                flex: 1,
                padding: '10px',
                backgroundColor: '#f3f4f6',
                color: '#374151',
                border: 'none',
                borderRadius: '6px',
                fontSize: '14px',
                fontWeight: '500',
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#e5e7eb'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#f3f4f6'}
            >
              إلغاء
            </button>
          </div>
        </div>
      </div>
    );

    return ReactDOM.createPortal(modalContent, this.modalRoot);
  }

  onSelectIn = async (selectedItem) => {
    try {
      const response = await axios.get(host + `users/parts/${selectedItem.id}`);
      this.setState({ 
        options: response.data.parts, 
        itemIn: selectedItem 
      });
    } catch (error) {
      console.error('Error loading parts:', error);
    }
  }

  getStatusBadge = (status) => {
    const statusMap = {
      "-1": { label: "معلق في الصيانة", color: "bg-gradient-to-r from-orange-400 to-orange-500 text-white shadow-sm", icon: AlertCircle },
      "0": { label: "سوفت", color: "bg-gradient-to-r from-blue-400 to-blue-500 text-white shadow-sm", icon: Wrench },
      "1": { label: "فحص", color: "bg-gradient-to-r from-purple-400 to-purple-500 text-white shadow-sm", icon: Search },
      "2": { label: "جاهز للمخزن", color: "bg-gradient-to-r from-green-400 to-green-500 text-white shadow-sm", icon: CheckCircle },
      "3": { label: "في المخزن", color: "bg-gradient-to-r from-gray-400 to-gray-500 text-white shadow-sm", icon: Package },
      "4": { label: "ملغي", color: "bg-gradient-to-r from-red-400 to-red-500 text-white shadow-sm", icon: XCircle },
      "5": { label: "معلق في السوفت", color: "bg-gradient-to-r from-yellow-400 to-yellow-500 text-white shadow-sm", icon: AlertCircle },
      "6": { label: "تم البيع", color: "bg-gradient-to-r from-red-400 to-red-500 text-white shadow-sm", icon: DollarSign }
    };

    const statusInfo = statusMap[status] || statusMap["1"];
    const Icon = statusInfo.icon;
    
    return (
      <span className={`inline-flex items-center gap-1 px-3 py-1.5 rounded-full text-xs font-medium ${statusInfo.color} transform hover:scale-105 transition-all`}>
        <Icon size={14} />
        {statusInfo.label}
      </span>
    );
  }

  render() {
    if (!this.state.spin) {
      return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center" style={{ direction: 'rtl' }}>
          <style dangerouslySetInnerHTML={{ __html: styles }} />
          <div className="text-center">
            <div className="bg-white p-8 rounded-xl shadow-md">
              <Loader2 className="w-12 h-12 animate-spin text-indigo-600 mx-auto" />
              <p className="mt-4 text-gray-600 font-medium">جاري تحميل البيانات...</p>
              <p className="mt-2 text-gray-400 text-sm">يرجى الانتظار</p>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100" style={{ direction: 'rtl' }}>
        <style dangerouslySetInnerHTML={{ __html: styles }} />
        
        {/* Header */}
        <div className="bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 text-white p-6 shadow-xl relative overflow-hidden">
          {/* Animated background shapes */}
          <div className="absolute inset-0 overflow-hidden">
            <div className="absolute -top-10 -right-10 w-40 h-40 bg-white/10 rounded-full blur-3xl"></div>
            <div className="absolute -bottom-10 -left-10 w-60 h-60 bg-white/10 rounded-full blur-3xl"></div>
          </div>
          
          <div className="max-w-7xl mx-auto relative z-10">
            <div className="flex items-center justify-between">
              <div>
                <h1 className="text-3xl font-bold flex items-center gap-3">
                  <div className="bg-white/20 backdrop-blur-sm p-2 rounded-xl">
                    <Smartphone className="w-8 h-8" />
                  </div>
                  <span className="gradient-text">إدارة الأجهزة</span>
                </h1>
                <p className="text-indigo-100 mt-2 text-lg">     جميع الاجهزة في قسم الصيانة </p>
              </div>
              <div className="flex gap-3">
    
              </div>
            </div>
          </div>
        </div>

        {/* Stats Cards - First Row */}
        <div className="max-w-7xl mx-auto px-4 -mt-8 relative z-20">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <div className="bg-white rounded-xl shadow-lg p-6 border-t-4 border-blue-500 hover:shadow-xl hover:-translate-y-1 transition-all cursor-pointer group" onClick={() => this.handleStatusFilter('all')}>
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-gray-500 text-sm group-hover:text-gray-600 transition-colors">إجمالي الأجهزة</p>
                  <p className="text-3xl font-bold mt-1 text-gray-800">{this.state.totalItems || 0}</p>
                  <p className="text-xs text-gray-400 mt-1">جميع الأجهزة في النظام</p>
                </div>
                <div className="bg-gradient-to-br from-blue-100 to-blue-200 p-3 rounded-lg group-hover:scale-110 transition-transform">
                  <Package className="w-6 h-6 text-blue-600" />
                </div>
              </div>
            </div>
            
            <div className="bg-white rounded-xl shadow-lg p-6 border-t-4 border-green-500 hover:shadow-xl hover:-translate-y-1 transition-all cursor-pointer group" onClick={() => this.handleStatusFilter("2")}>
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-gray-500 text-sm group-hover:text-gray-600 transition-colors">جاهز للمخزن</p>
                  <p className="text-3xl font-bold mt-1 text-gray-800">
                    {this.state.statusStats["2"] || 0}
                  </p>
                  <p className="text-xs text-green-600 mt-1">انقر للفلترة</p>
                </div>
                <div className="bg-gradient-to-br from-green-100 to-green-200 p-3 rounded-lg group-hover:scale-110 transition-transform">
                  <CheckCircle className="w-6 h-6 text-green-600" />
                </div>
              </div>
            </div>
            
            <div className="bg-white rounded-xl shadow-lg p-6 border-t-4 border-yellow-500 hover:shadow-xl hover:-translate-y-1 transition-all group">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-gray-500 text-sm group-hover:text-gray-600 transition-colors">قيد الصيانة</p>
                  <p className="text-3xl font-bold mt-1 text-gray-800">
                    {(this.state.statusStats["-1"] || 0) + (this.state.statusStats["0"] || 0) + (this.state.statusStats["1"] || 0) + (this.state.statusStats["5"] || 0)}
                  </p>
                  <p className="text-xs text-yellow-600 mt-1">صيانة + سوفت + فحص</p>
                </div>
                <div className="bg-gradient-to-br from-yellow-100 to-yellow-200 p-3 rounded-lg group-hover:scale-110 transition-transform">
                  <Wrench className="w-6 h-6 text-yellow-600" />
                </div>
              </div>
            </div>
            
            <div className="bg-white rounded-xl shadow-lg p-6 border-t-4 border-purple-500 hover:shadow-xl hover:-translate-y-1 transition-all group">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-gray-500 text-sm group-hover:text-gray-600 transition-colors">متوسط البطارية</p>
                  <div className="flex items-center gap-2 mt-1">
                    <p className="text-3xl font-bold text-gray-800">{Math.round(this.state.battery_avg || 0)}%</p>
                    <div className="w-16 bg-gray-200 rounded-full h-2">
                      <div 
                        className={`h-2 rounded-full transition-all ${
                          this.state.battery_avg > 80 ? 'bg-green-500' : 
                          this.state.battery_avg > 50 ? 'bg-yellow-500' : 'bg-red-500'
                        }`}
                        style={{ width: `${Math.min(this.state.battery_avg || 0, 100)}%` }}
                      />
                    </div>
                  </div>
                </div>
                <div className="bg-gradient-to-br from-purple-100 to-purple-200 p-3 rounded-lg group-hover:scale-110 transition-transform">
                  <Battery className="w-6 h-6 text-purple-600" />
                </div>
              </div>
            </div>
          </div>

          {/* Detailed Status Stats */}
          <div className="mt-6 bg-white rounded-xl shadow-lg p-6">
            <h3 className="text-lg font-semibold mb-4 text-gray-800 flex items-center gap-2">
              <Package className="w-5 h-5 text-gray-600" />
              إحصائيات تفصيلية حسب الحالة
            </h3>
            <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-4">
              <div 
                className="text-center p-3 bg-orange-50 rounded-lg border border-orange-200 hover:shadow-md hover:scale-105 transition-all cursor-pointer"
                onClick={() => this.handleStatusFilter("-1")}
              >
                <AlertCircle className="w-8 h-8 text-orange-600 mx-auto mb-2" />
                <p className="text-xs text-gray-600 font-medium">معلق في الصيانة</p>
                <p className="text-xl font-bold text-orange-700">
                  {this.state.statusStats["-1"] || 0}
                </p>
              </div>
              <div 
                className="text-center p-3 bg-blue-50 rounded-lg border border-blue-200 hover:shadow-md hover:scale-105 transition-all cursor-pointer"
                onClick={() => this.handleStatusFilter("0")}
              >
                <Wrench className="w-8 h-8 text-blue-600 mx-auto mb-2" />
                <p className="text-xs text-gray-600 font-medium">سوفت</p>
                <p className="text-xl font-bold text-blue-700">
                  {this.state.statusStats["0"] || 0}
                </p>
              </div>
              <div 
                className="text-center p-3 bg-purple-50 rounded-lg border border-purple-200 hover:shadow-md hover:scale-105 transition-all cursor-pointer"
                onClick={() => this.handleStatusFilter("1")}
              >
                <Search className="w-8 h-8 text-purple-600 mx-auto mb-2" />
                <p className="text-xs text-gray-600 font-medium">فحص</p>
                <p className="text-xl font-bold text-purple-700">
                  {this.state.statusStats["1"] || 0}
                </p>
              </div>
              <div 
                className="text-center p-3 bg-green-50 rounded-lg border border-green-200 hover:shadow-md hover:scale-105 transition-all cursor-pointer"
                onClick={() => this.handleStatusFilter("2")}
              >
                <CheckCircle className="w-8 h-8 text-green-600 mx-auto mb-2" />
                <p className="text-xs text-gray-600 font-medium">جاهز للمخزن</p>
                <p className="text-xl font-bold text-green-700">
                  {this.state.statusStats["2"] || 0}
                </p>
              </div>
              <div 
                className="text-center p-3 bg-gray-50 rounded-lg border border-gray-200 hover:shadow-md hover:scale-105 transition-all cursor-pointer"
                onClick={() => this.handleStatusFilter("3")}
              >
                <Package className="w-8 h-8 text-gray-600 mx-auto mb-2" />
                <p className="text-xs text-gray-600 font-medium">في المخزن</p>
                <p className="text-xl font-bold text-gray-700">
                  {this.state.statusStats["3"] || 0}
                </p>
              </div>
              <div 
                className="text-center p-3 bg-red-50 rounded-lg border border-red-200 hover:shadow-md hover:scale-105 transition-all cursor-pointer"
                onClick={() => this.handleStatusFilter("4")}
              >
                <XCircle className="w-8 h-8 text-red-600 mx-auto mb-2" />
                <p className="text-xs text-gray-600 font-medium">ملغي</p>
                <p className="text-xl font-bold text-red-700">
                  {this.state.statusStats["4"] || 0}
                </p>
              </div>
              <div 
                className="text-center p-3 bg-yellow-50 rounded-lg border border-yellow-200 hover:shadow-md hover:scale-105 transition-all cursor-pointer"
                onClick={() => this.handleStatusFilter("5")}
              >
                <AlertCircle className="w-8 h-8 text-yellow-600 mx-auto mb-2" />
                <p className="text-xs text-gray-600 font-medium">معلق في السوفت</p>
                <p className="text-xl font-bold text-yellow-700">
                  {this.state.statusStats["5"] || 0}
                </p>
              </div>
              <div 
                className="text-center p-3 bg-emerald-50 rounded-lg border border-emerald-200 hover:shadow-md hover:scale-105 transition-all cursor-pointer"
                onClick={() => this.handleStatusFilter("6")}
              >
                <DollarSign className="w-8 h-8 text-emerald-600 mx-auto mb-2" />
                <p className="text-xs text-gray-600 font-medium">تم البيع</p>
                <p className="text-xl font-bold text-emerald-700">
                  {this.state.statusStats["6"] || 0}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Filters */}
        <div className="max-w-7xl mx-auto px-4 mt-8">
          <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-100">
            <h3 className="text-lg font-semibold mb-4 text-gray-800 flex items-center gap-2">
              <Filter className="w-5 h-5 text-gray-600" />
              البحث والفلترة
            </h3>
            <div className="flex flex-col md:flex-row gap-4">
              <div className="flex-1">
                <div className="relative">
                  <Search className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
                  <input
                    type="text"
                    placeholder="بحث بالاسم، ECID، أو نوع الجهاز..."
                    className="w-full pr-10 pl-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all text-sm placeholder-gray-400 hover:border-gray-400"
                    value={this.state.searchTerm}
                    onChange={(e) => this.handleSearch(e.target.value)}
                  />
                </div>
              </div>
              
              <div className="flex gap-2">
                <select
                  className="px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 text-sm hover:border-gray-400 transition-all cursor-pointer"
                  value={this.state.statusFilter}
                  onChange={(e) => this.handleStatusFilter(e.target.value)}
                >
                  <option value="all">جميع الحالات</option>
                  <option value="-1">معلق في الصيانة ({this.state.statusStats["-1"] || 0})</option>
                  <option value="0">سوفت ({this.state.statusStats["0"] || 0})</option>
                  <option value="1">فحص ({this.state.statusStats["1"] || 0})</option>
                  <option value="2">جاهز للمخزن ({this.state.statusStats["2"] || 0})</option>
                  <option value="3">في المخزن ({this.state.statusStats["3"] || 0})</option>
                  <option value="4">ملغي ({this.state.statusStats["4"] || 0})</option>
                  <option value="5">معلق في السوفت ({this.state.statusStats["5"] || 0})</option>
                  <option value="6">تم البيع ({this.state.statusStats["6"] || 0})</option>
                </select>
                
                <button className="px-4 py-3 bg-gradient-to-r from-gray-100 to-gray-200 text-gray-700 rounded-lg hover:from-gray-200 hover:to-gray-300 transition-all flex items-center gap-2 text-sm hover:scale-105 transform font-medium">
                  <Filter size={18} />
                  <span>فلاتر متقدمة</span>
                </button>
              </div>
            </div>
            
            {/* Active Filters Display */}
            {(this.state.searchTerm || this.state.statusFilter !== 'all') && (
              <div className="mt-4 flex items-center gap-2 flex-wrap">
                <span className="text-sm text-gray-600 font-medium">الفلاتر النشطة:</span>
                {this.state.searchTerm && (
                  <span className="inline-flex items-center gap-1 px-3 py-1.5 bg-indigo-50 text-indigo-700 rounded-full text-sm font-medium border border-indigo-200 hover:bg-indigo-100 transition-colors">
                    <Search size={14} />
                    البحث: {this.state.searchTerm}
                    <button 
                      onClick={() => this.handleSearch('')}
                      className="ml-1 hover:text-indigo-900 hover:bg-indigo-200 rounded-full p-0.5 transition-all"
                    >
                      <X size={14} />
                    </button>
                  </span>
                )}
                {this.state.statusFilter !== 'all' && (
                  <span className="inline-flex items-center gap-1 px-3 py-1.5 bg-purple-50 text-purple-700 rounded-full text-sm font-medium border border-purple-200 hover:bg-purple-100 transition-colors">
                    الحالة: {this.getStatusBadge(this.state.statusFilter)}
                    <button 
                      onClick={() => this.handleStatusFilter('all')}
                      className="ml-1 hover:text-purple-900 hover:bg-purple-200 rounded-full p-0.5 transition-all"
                    >
                      <X size={14} />
                    </button>
                  </span>
                )}
                <button
                  onClick={() => {
                    this.handleSearch('');
                    this.handleStatusFilter('all');
                  }}
                  className="text-xs text-red-600 hover:text-red-700 underline font-medium"
                >
                  مسح جميع الفلاتر
                </button>
              </div>
            )}
          </div>
        </div>

        {/* Table */}
        <div className="max-w-7xl mx-auto px-4 mt-6 pb-10">
          <div className="bg-white rounded-xl shadow-lg border border-gray-100">
            <div className="overflow-x-auto rounded-xl scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100 relative">
              {/* Table Loading Spinner */}
              {this.state.isTableLoading && (
                <div className="absolute inset-0 bg-white/90 backdrop-blur-sm z-10 flex items-center justify-center rounded-xl animate-fadeIn">
                  <div className="flex flex-col items-center gap-4 animate-slideInUp">
                    <div className="relative">
                      <div className="absolute inset-0 bg-indigo-600 rounded-full opacity-20 animate-ping"></div>
                      <Loader2 className="w-12 h-12 animate-spin text-indigo-600 relative z-10" />
                    </div>
                    <div className="text-center">
                      <p className="text-gray-700 font-semibold">جاري تحميل البيانات...</p>
                      <p className="text-gray-500 text-sm mt-1">الرجاء الانتظار</p>
                    </div>
                  </div>
                </div>
              )}
              <table className={`w-full min-w-[1400px] table-transition ${this.state.isTableLoading ? 'table-loading' : ''}`}>
                <thead className="bg-gradient-to-r from-gray-50 to-gray-100 border-b border-gray-200">
                  <tr>
                    <th className="px-4 py-4 text-right text-sm font-semibold text-gray-900 w-16">
                      <div className="flex items-center gap-1">
                        <Hash size={14} />
                        #
                      </div>
                    </th>
                    <th className="px-4 py-4 text-right text-sm font-semibold text-gray-900 w-32">ECID</th>
                    <th className="px-4 py-4 text-right text-sm font-semibold text-gray-900 w-32">
                      <div className="flex items-center gap-1">
                        <User size={14} />
                        الموظف
                      </div>
                    </th>
                    <th className="px-4 py-4 text-right text-sm font-semibold text-gray-900 w-40">الجهاز الأولي</th>
                    <th className="px-4 py-4 text-right text-sm font-semibold text-gray-900 w-40">الجهاز النهائي</th>
                    <th className="px-4 py-4 text-right text-sm font-semibold text-gray-900 w-20">تخطي</th>
                    <th className="px-4 py-4 text-right text-sm font-semibold text-gray-900 w-36">الحالة</th>
                    <th className="px-4 py-4 text-right text-sm font-semibold text-gray-900 w-32">
                      <div className="flex items-center gap-1">
                        <Battery size={14} />
                        البطارية
                      </div>
                    </th>
                    <th className="px-4 py-4 text-right text-sm font-semibold text-gray-900 w-28">التكاليف</th>
                    <th className="px-4 py-4 text-right text-sm font-semibold text-gray-900 w-28">القائمة</th>
                    <th className="px-4 py-4 text-right text-sm font-semibold text-gray-900 w-24">
                      <div className="flex items-center gap-1">
                        <Calendar size={14} />
                        التحديث
                      </div>
                    </th>
                    <th className="px-4 py-4 text-center text-sm font-semibold text-gray-900 w-24">الإجراءات</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {this.state.filteredDevices.map((device, index) => {
                    const actualIndex = (this.state.currentPage - 1) * this.state.itemsPerPage + index;
                    return (
                    <tr key={device.id} className={`hover:bg-indigo-50/50 transition-all duration-200 cursor-pointer ${actualIndex % 2 === 0 ? 'bg-white' : 'bg-gray-50/50'}`}>
                      <td className="px-4 py-3 text-sm text-gray-900 font-bold">{device.id}</td>
                      <td className="px-4 py-3 text-sm">
                        <span className="font-mono bg-gradient-to-r from-indigo-50 to-purple-50 text-indigo-700 px-2 py-1 rounded text-xs border border-indigo-200">
                          {device.uudi || '-'}
                        </span>
                      </td>
                      <td className="px-4 py-3">
                        <div className="flex items-center gap-2">
                          <div className="w-8 h-8 bg-gradient-to-br from-indigo-400 to-purple-400 rounded-full flex items-center justify-center text-white text-xs font-bold shadow-sm">
                            {device.name?.charAt(0) || '؟'}
                          </div>
                          <span className="text-sm text-gray-900 font-medium truncate max-w-[100px]" title={device.name}>
                            {device.name || '-'}
                          </span>
                        </div>
                      </td>
                      <td className="px-4 py-3">
                        <div className="flex items-center gap-1">
                          <Smartphone size={14} className="text-gray-400" />
                          <span className="text-sm text-gray-900 font-medium truncate max-w-[140px]" title={device.item_in}>
                            {device.item_in || '-'}
                          </span>
                        </div>
                      </td>
                      <td className="px-4 py-3">
                        <div className="flex items-center gap-1">
                          <Smartphone size={14} className="text-indigo-400" />
                          <span className="text-sm text-gray-900 font-medium truncate max-w-[140px]" title={device.item_out}>
                            {device.item_out || '-'}
                          </span>
                        </div>
                      </td>
                      <td className="px-4 py-3">
                        {device.paybass !== undefined ? (
                          <span className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium transform hover:scale-105 transition-all ${
                            device.paybass 
                              ? 'bg-gradient-to-r from-green-400 to-green-500 text-white shadow-sm' 
                              : 'bg-gradient-to-r from-gray-400 to-gray-500 text-white shadow-sm'
                          }`}>
                            {device.paybass && <CheckCircle size={12} />}
                            {device.paybassLabel}
                          </span>
                        ) : (
                          <span className="text-gray-400 text-xs">-</span>
                        )}
                      </td>
                      <td className="px-4 py-3">{this.getStatusBadge(device.status)}</td>
                      <td className="px-4 py-3">
                        {device.battery ? (
                          <div className="flex items-center gap-2">
                            <div className="w-20 bg-gray-200 rounded-full h-2.5 relative overflow-hidden">
                              <div 
                                className={`h-full rounded-full transition-all relative ${
                                  device.battery > 80 ? 'bg-gradient-to-r from-green-400 to-green-500' : 
                                  device.battery > 50 ? 'bg-gradient-to-r from-yellow-400 to-yellow-500' : 
                                  'bg-gradient-to-r from-red-400 to-red-500'
                                }`}
                                style={{ width: `${Math.min(device.battery, 100)}%` }}
                              >
                                <div className="absolute inset-0 bg-white/20"></div>
                              </div>
                            </div>
                            <span className={`text-xs font-bold w-10 ${
                              device.battery > 80 ? 'text-green-600' : 
                              device.battery > 50 ? 'text-yellow-600' : 
                              'text-red-600'
                            }`}>
                              {device.battery}%
                            </span>
                          </div>
                        ) : (
                          <span className="text-gray-400 text-xs">-</span>
                        )}
                      </td>
                      <td className="px-4 py-3">
                        <div className="text-xs space-y-1">
                          <div className="flex items-center justify-between bg-gray-50 rounded px-2 py-1">
                            <span className="text-gray-600">قطع:</span>
                            <span className="font-bold text-gray-800">{device.parts_costs || 0}</span>
                          </div>
                          <div className="flex items-center justify-between bg-indigo-50 rounded px-2 py-1">
                            <span className="text-gray-600">سوفت:</span>
                            <span className="font-bold text-indigo-700">{device.softCost || 0}</span>
                          </div>
                        </div>
                      </td>
                      <td className="px-4 py-3">
                        {device.list ? (
                          <a 
                            href={`/SanaBill?id=${device.list}`} 
                            className="inline-flex items-center gap-1 text-indigo-600 hover:text-indigo-800 font-medium text-sm hover:bg-indigo-50 px-2 py-1 rounded transition-all"
                          >
                            <span>{device.list}</span>
                            <ChevronRight size={14} className="transform group-hover:translate-x-1 transition-transform" />
                          </a>
                        ) : (
                          <span className="text-gray-400 text-xs">-</span>
                        )}
                      </td>
                      <td className="px-4 py-3">
                        <div className="flex items-center gap-1 text-xs">
                          <Calendar size={12} className="text-gray-400" />
                          <span className="text-gray-700 font-medium" title={`إنشاء: ${device.createdAtFormatted}`}>
                            {device.updatedAtFormatted}
                          </span>
                        </div>
                      </td>
                      <td className="px-4 py-3 text-center">
                        {device.canEdit ? (
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              this.setState({ 
                                selectedDevice: device, 
                                isEditModalOpen: true,
                                selectedStatus: device.status || '', // تعيين الحالة الحالية هنا
                                itemIn: {},
                                itemOut: {},
                                options: []
                              });
                              console.log('Opening edit modal for device:', device.id, 'with status:', device.status);
                            }}
                            className="text-white bg-gradient-to-r from-indigo-500 to-purple-500 hover:from-indigo-600 hover:to-purple-600 p-2 rounded-lg transition-all duration-200 inline-flex items-center justify-center shadow-sm hover:shadow-md transform hover:scale-110"
                          >
                            <Edit2 size={16} />
                          </button>
                        ) : (
                          <span className="text-gray-400 text-xs bg-gray-100 px-2 py-1 rounded">لا يمكن</span>
                        )}
                      </td>
                    </tr>
                  );})}
                  
                  {this.state.filteredDevices.length === 0 && (
                    <tr>
                      <td colSpan="12" className="px-4 py-16 text-center">
                        <div className="flex flex-col items-center gap-3">
                          <Package className="w-16 h-16 text-gray-300" />
                          <p className="text-gray-500 text-lg font-medium">لا توجد بيانات للعرض</p>
                          <p className="text-gray-400 text-sm">قم بتغيير معايير البحث أو الفلاتر</p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            
            {/* Table Footer with Pagination Info */}
            <div className="px-6 py-4 border-t border-gray-200 bg-gray-50 rounded-b-xl">
              <div className="flex items-center justify-between flex-wrap gap-4">
                <div className="text-sm text-gray-600">
                  عرض <span className="font-semibold text-gray-800">
                    {Math.min((this.state.currentPage - 1) * this.state.itemsPerPage + 1, this.state.totalItems || 0)}
                  </span> - <span className="font-semibold text-gray-800">
                    {Math.min(this.state.currentPage * this.state.itemsPerPage, this.state.totalItems || 0)}
                  </span> من إجمالي <span className="font-semibold text-gray-800">{this.state.totalItems || 0}</span> جهاز
                </div>
                
                {/* Pagination Controls */}
                <div className="flex items-center gap-4 flex-wrap">
                  <div className="flex items-center gap-2">
                    <span className="text-sm text-gray-600">عدد العناصر:</span>
                    <select
                      value={this.state.itemsPerPage}
                      onChange={(e) => this.handleItemsPerPageChange(e.target.value)}
                      disabled={this.state.isTableLoading}
                      className={`px-3 py-2 border rounded-lg focus:ring-2 focus:ring-indigo-500 text-sm transition-all ${
                        this.state.isTableLoading
                          ? 'bg-gray-100 text-gray-400 cursor-not-allowed border-gray-200'
                          : 'border-gray-300 hover:border-gray-400 cursor-pointer'
                      }`}
                    >
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                    </select>
                  </div>
                  
                  {/* Current Page Indicator */}
                  <div className="bg-gradient-to-r from-indigo-100 to-purple-100 border-2 border-indigo-300 px-4 py-2 rounded-lg shadow-sm">
                    <span className="text-sm text-indigo-700 font-medium">
                      الصفحة: 
                      <span className="text-xl font-bold text-indigo-800 mx-2 bg-white px-2 py-1 rounded">
                        {this.state.currentPage}
                      </span>
                      من <span className="font-semibold">{this.state.totalPages}</span>
                    </span>
                  </div>
                  
                  <div className="flex items-center gap-2">{/* Rest of pagination controls */}
                  <button
                    onClick={() => this.handlePageChange(Math.max(1, this.state.currentPage - 1))}
                    disabled={this.state.currentPage === 1 || this.state.isTableLoading}
                    className={`p-2 rounded-lg transition-all ${
                      this.state.currentPage === 1 || this.state.isTableLoading
                        ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                        : 'bg-white text-gray-700 hover:bg-indigo-50 hover:text-indigo-700 border border-gray-300'
                    }`}
                  >
                    <ChevronRight size={16} />
                  </button>
                  
                  <div className="flex items-center gap-1 pb-8">
                    {[...Array(Math.min(5, this.state.totalPages))].map((_, index) => {
                      let pageNum;
                      if (this.state.totalPages <= 5) {
                        pageNum = index + 1;
                      } else if (this.state.currentPage <= 3) {
                        pageNum = index + 1;
                      } else if (this.state.currentPage >= this.state.totalPages - 2) {
                        pageNum = this.state.totalPages - 4 + index;
                      } else {
                        pageNum = this.state.currentPage - 2 + index;
                      }
                      
                      const isCurrentPage = pageNum === this.state.currentPage;
                      
                      return (
                        <button
                          key={index}
                          onClick={() => !isCurrentPage && this.handlePageChange(pageNum)}
                          disabled={this.state.isTableLoading || isCurrentPage}
                          className={`min-w-[45px] h-12 px-3 py-2 rounded-lg transition-all relative ${
                            isCurrentPage
                              ? 'bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-bold shadow-lg scale-110 ring-4 ring-indigo-300 ring-opacity-50 cursor-default current-page-pulse transform -translate-y-1'
                              : this.state.isTableLoading
                              ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                              : 'bg-white text-gray-700 hover:bg-indigo-50 hover:text-indigo-700 border border-gray-300 hover:scale-105'
                          }`}
                          title={isCurrentPage ? 'الصفحة الحالية' : `الذهاب إلى صفحة ${pageNum}`}
                        >
                          {isCurrentPage && (
                            <>
                              <span className="absolute -top-3 -right-3 w-6 h-6 bg-green-500 rounded-full flex items-center justify-center text-xs text-white shadow-md animate-bounce">
                                ✓
                              </span>
                              <span className="absolute -bottom-7 left-1/2 transform -translate-x-1/2 text-xs text-indigo-600 font-bold whitespace-nowrap bg-indigo-50 px-2 py-0.5 rounded border border-indigo-200">
                                أنت هنا
                              </span>
                            </>
                          )}
                          <span className={isCurrentPage ? 'text-lg' : ''}>{pageNum}</span>
                        </button>
                      );
                    })}
                    
                    {this.state.totalPages > 5 && (
                      <div className="flex items-center gap-2 mx-2">
                        <span className="text-gray-500">من</span>
                        <span className="font-bold text-gray-700">{this.state.totalPages}</span>
                        <span className="text-gray-500">صفحة</span>
                      </div>
                    )}
                  </div>
                  
                  <button
                    onClick={() => this.handlePageChange(Math.min(this.state.totalPages, this.state.currentPage + 1))}
                    disabled={this.state.currentPage === this.state.totalPages || this.state.isTableLoading}
                    className={`p-2 rounded-lg transition-all ${
                      this.state.currentPage === this.state.totalPages || this.state.isTableLoading
                        ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                        : 'bg-white text-gray-700 hover:bg-indigo-50 hover:text-indigo-700 border border-gray-300'
                    }`}
                  >
                    <ChevronLeft size={16} />
                  </button>
                </div>
                </div>
                
                <div className="flex items-center gap-4 flex-wrap">
                  <div className="flex items-center gap-2">
                    <span className="text-sm text-gray-600">تكلفة قطع الغيار:</span>
                    <span className="font-bold text-gray-800 bg-white px-3 py-1 rounded border border-gray-200">
                      {(this.state.parts_cost || 0).toLocaleString()} د.ع
                    </span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="text-sm text-gray-600">تكلفة السوفت:</span>
                    <span className="font-bold text-gray-800 bg-white px-3 py-1 rounded border border-gray-200">
                      {(this.state.softCost || 0).toLocaleString()} د.ع
                    </span>
                  </div>
                  <div className="flex items-center gap-2">
                    <span className="text-sm text-gray-600">الإجمالي:</span>
                    <span className="font-bold text-indigo-700 bg-indigo-50 px-3 py-1 rounded border border-indigo-200">
                      {((this.state.parts_cost || 0) + (this.state.softCost || 0)).toLocaleString()} د.ع
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Edit Modal - استبدال كامل */}
        {this.renderModal()}
      </div>
    );
  }
}

export default ModernDeviceManagement;